export const API = {
  fundPrices: "https://portal.manulife.com.vn/s/bff/fund/prices",
  fundFees: "https://portal.manulife.com.vn/s/bff/fund/management-fees"
};
